export default {
  idleTimeout: 30,
  partnerHub: 'https://hub.chaserhq.com',
  apiUrl: 'http://localhost:9091',
  drmApiUrl: 'http://localhost:9200',
  cspReportUri:
    'https://sentry.chaserhq.com/api/5/security/?sentry_key=0c14462d45804f868521aa57b750ca2f',
  chargebeeSite: 'chaser-test',
  sentryEnvironment: 'test',
  firebaseProjectId: undefined,
  firebaseApiKey: undefined,
  firebaseAppId: undefined,
  pendoAgentId: undefined,
  enableDevToolsExtension: '1',
  enableLogs: '1',
};
